import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
})
export class ModalComponent {
  @Input() size: 'default' | 'small' | 'medium' | 'medium-2' | 'large' = 'medium';
  @Input() class: string = '';
  @Input() backdropDismiss: boolean = false;
  @Input() style: string = '';
  @Input() open: boolean = false;
  @Output() dismiss = new EventEmitter<any>();

  constructor() { }

  onCancel() {
    this.dismiss?.emit();
  }
}
